"use client";

import { GoogleSignInButton } from "@/modules/auth/components/google-signin-button";

export default function LoginPage() {
  return (
    <div className="space-y-6">
      <div className="space-y-2 text-center">
        <h1 className="text-3xl font-bold">Welcome back</h1>
        <p className="text-muted-foreground">
          Sign in to your account to continue
        </p>
      </div>

      <div className="space-y-4">
        <GoogleSignInButton className="w-full" />
        
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <span className="w-full border-t" />
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-background px-2 text-muted-foreground">
              More options coming soon
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
